var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextDropdownOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#EEEEEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4178_12839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7201 14.717L17.3807 15.0742C17.3749 15.0803 17.3663 15.0823 17.3586 15.0893L12.9754 19.7041C12.6006 20.0986 11.9937 20.0986 11.6198 19.7041L11.2804 19.3479C10.9065 18.9533 10.9065 18.3145 11.2804 17.921L15.005 13.9995L11.2804 10.079C10.9065 9.68549 10.9065 9.04571 11.2804 8.65114L11.6198 8.29593C11.9937 7.90136 12.6006 7.90136 12.9754 8.29593L17.3586 12.9096C17.3653 12.9167 17.3749 12.9187 17.3807 12.9258L17.7201 13.282C17.908 13.4798 18.001 13.7402 18 13.9995C18.001 14.2598 17.908 14.5192 17.7201 14.717Z",
    fill: "#212129"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4178_12839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(20.5 8) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextDropdownOption);
export default __webpack_public_path__ + "static/media/next-dropdown-option.c97fa090007615187f2878c00c2dddc3.svg";
export { ForwardRef as ReactComponent };